import { render, staticRenderFns } from "./parcel.vue?vue&type=template&id=41e820f5&scoped=true"
import script from "./parcel.vue?vue&type=script&lang=js"
export * from "./parcel.vue?vue&type=script&lang=js"
import style0 from "./parcel.vue?vue&type=style&index=0&id=41e820f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e820f5",
  null
  
)

export default component.exports